var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5045 30.1417L50.3389 53.9931L12.6889 52.0135L7.55371 29.9282L43.5045 30.1417Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5045 29.9282L37.9508 57.8937L0.300781 55.9141L7.26913 29.9282H43.5045Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7254 29.9282L36.6279 55.5876L2.0791 53.7713L8.47407 29.9282H41.7254Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9236 32.8951L13.9484 37.1012L9.69629 37.0091L10.6714 32.7988L14.9236 32.8951Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9321 41.8223L11.957 46.0285L7.70898 45.9364L8.67995 41.7261L12.9321 41.8223Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1892 33.0545L21.2141 37.2606L16.9619 37.1685L17.9329 32.9624L22.1892 33.0545Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.197 41.9812L19.2219 46.1915L14.9697 46.0953L15.9407 41.8892L20.197 41.9812Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5388 33.2176L28.5637 37.4237L24.3115 37.3316L25.2867 33.1255L29.5388 33.2176Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5466 42.1443L26.5715 46.3504L22.3193 46.2584L23.2945 42.0522L27.5466 42.1443Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7996 33.3767L35.8244 37.587L31.5723 37.4908L32.5474 33.2847L36.7996 33.3767Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8074 42.3035L33.8322 46.5138L29.5801 46.4175L30.5552 42.2114L34.8074 42.3035Z",
    fill: "#F5FAFD",
    stroke: "#A2CCEE",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6375 40.6421C48.73 40.6421 57.7222 31.6499 57.7222 20.5574C57.7222 9.4649 48.73 0.472656 37.6375 0.472656C26.545 0.472656 17.5527 9.4649 17.5527 20.5574C17.5527 31.6499 26.545 40.6421 37.6375 40.6421Z",
    fill: "white",
    stroke: "#009DD1",
    strokeWidth: 0.167408,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6379 38.3779C47.4799 38.3779 55.4585 30.3994 55.4585 20.5574C55.4585 10.7153 47.4799 2.73682 37.6379 2.73682C27.7959 2.73682 19.8174 10.7153 19.8174 20.5574C19.8174 30.3994 27.7959 38.3779 37.6379 38.3779Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6379 38.3779C47.4799 38.3779 55.4585 30.3994 55.4585 20.5574C55.4585 10.7153 47.4799 2.73682 37.6379 2.73682C27.7959 2.73682 19.8174 10.7153 19.8174 20.5574C19.8174 30.3994 27.7959 38.3779 37.6379 38.3779Z",
    stroke: "#009DD1",
    strokeWidth: 4.18519,
    strokeMiterlimit: 10,
    strokeDasharray: "0.42 9.63"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8213 28.4004L24.4043 25.9604L22.8977 33.7156L18.8213 28.4004Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1781 26.241L22.8053 33.3182L19.0847 28.4675L24.1781 26.241ZM24.6301 25.6802L18.5615 28.3336L22.9978 34.1133L24.6342 25.6802H24.6301Z",
    fill: "#005EB8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3109 27.258L9.60077 32.1254L4.38184 6.41992L33.6907 21.7963L25.9146 26.739L23.0478 33.5986L21.3109 27.258Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6123 6.73395L33.3562 21.8132L25.8647 26.5718L25.7768 26.6262L25.735 26.7224L23.0774 33.0881L21.5163 27.3962L21.4158 27.0279L21.0643 27.1744L9.71823 31.8953L4.6123 6.73395ZM4.14355 6.11035L9.47549 32.3599L21.1982 27.4841L23.0146 34.1135L26.0447 26.8522L34.0258 21.7839L4.14774 6.11035H4.14355Z",
    fill: "#005EB8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3527 27.409L5.77539 7.88086L25.8476 26.8942L23.0477 33.5989L21.3527 27.409Z",
    fill: "#CCDEF2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40354 9.65521L25.651 26.9359L23.0813 33.0881L21.5202 27.3962L21.5035 27.3293L21.4616 27.2749L7.40354 9.65521ZM4.14746 6.11035L21.2021 27.4883L23.0185 34.1177L26.0486 26.8563L4.14746 6.11035Z",
    fill: "#005EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFlights);
export default __webpack_public_path__ + "static/media/no-flights.a0418df1f9545245ea41ba80409ed000.svg";
export { ForwardRef as ReactComponent };